module.exports = __webpack_public_path__ + "static/media/abudhabilog.d724d6ed.png";